
/// <reference path='../_all.ts' />

module product_references {
  'use strict';

  export class ProductReferenceData {
    constructor(
      public References: ProductReference[],
      public Countries: string[],
      public MeasuringTasks: string[],
      public Industries: string[],
      public showProductFilter?: boolean
      )
    {
    }
  }
}


